import { type SexSchema, sexSchema } from '@coas/validators/const';
import { atom } from 'jotai';

export const categoryStateAtom = atom<{ sex: SexSchema }>({
    sex: sexSchema.enum.man,
});
